import store from '@/store';

export default () => [
    {
        id: 'offer-report',
        name: 'Offer Report',
        to: { name: 'OfferReport' },
    },
    {
        id: 'traffic-source-report',
        name: 'Publisher Report',
        to: { name: 'TrafficSourceReport' },
    },
    {
        id: 'advertiser-report',
        name: 'Advertiser Report',
        to: { name: 'AdvertiserReport' },
    },
    {
        id: 'events-report',
        name: 'Events Report',
        to: { name: 'EventsReport' },
    },
    {
        id: 'postbacks-report',
        name: 'Postbacks Report',
        to: { name: 'PostbacksReport' },
    },
    {
        id: 'clicks-report',
        name: 'Clicks Report',
        to: { name: 'ClicksReport' },
    },
    {
        id: 'blocked-clicks-report',
        name: 'Blocked Clicks Report',
        to: { name: 'BlockedClicksReport' },
    },
    {
        id: 'fraud-report',
        name: 'Fraud Report',
        to: { name: 'FraudReport' },
    },
    {
        id: 'server-report',
        name: 'Server Report',
        to: { name: 'ServerReport' },
    },
    {
        id: 'custom-report',
        name: 'Custom Reports',
        to: { name: 'CustomReports' },
    },
    store?.getters?.config?.feature?.manual_adjustment?.enabled && store?.getters?.isCurrentUserAdmin && {
        id: 'manual-adjustment',
        name: 'Manual Adjustment',
        to: { name: 'ManualAdjustment' },
    },
].filter(Boolean);
